import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, toDisplayString as _toDisplayString, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/close100.png'


const _withScopeId = n => (_pushScopeId("data-v-6e513df5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16.3153 2.53125H12.9375V1.125C12.9375 0.975816 12.8782 0.832742 12.7728 0.727252C12.6673 0.621763 12.5242 0.5625 12.375 0.5625H5.625C5.47582 0.5625 5.33275 0.621763 5.22726 0.727252C5.12177 0.832742 5.06251 0.975816 5.06251 1.125V2.53125H1.68469C1.53551 2.53125 1.39243 2.59051 1.28694 2.696C1.18146 2.80149 1.12219 2.94457 1.12219 3.09375C1.12219 3.24293 1.18146 3.38601 1.28694 3.4915C1.39243 3.59699 1.53551 3.65625 1.68469 3.65625H2.27813L3.64782 15.9373C3.69389 16.3498 3.89038 16.7309 4.19972 17.0076C4.50906 17.2844 4.90955 17.4374 5.32463 17.4375H12.6748C13.09 17.4375 13.4905 17.2844 13.7999 17.0077C14.1094 16.7309 14.306 16.3499 14.3522 15.9373L15.7219 3.65625H16.3148C16.3886 3.65629 16.4618 3.64177 16.53 3.61354C16.5983 3.58531 16.6603 3.5439 16.7126 3.4917C16.7648 3.43949 16.8063 3.3775 16.8346 3.30927C16.8629 3.24104 16.8775 3.1679 16.8775 3.09403C16.8776 3.02016 16.8631 2.94701 16.8348 2.87875C16.8066 2.81049 16.7652 2.74846 16.713 2.6962C16.6608 2.64394 16.5988 2.60248 16.5306 2.57418C16.4623 2.54587 16.3892 2.53129 16.3153 2.53125ZM6.1875 1.6875H11.8125V2.53125H6.1875V1.6875ZM13.2345 15.8124C13.2191 15.95 13.1536 16.077 13.0505 16.1693C12.9473 16.2615 12.8138 16.3125 12.6754 16.3125H5.32463C5.18624 16.3125 5.0527 16.2615 4.94954 16.1693C4.84639 16.077 4.78087 15.95 4.76551 15.8124L3.40988 3.65625H14.5901L13.2345 15.8124Z",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.6875 14.4304C10.8367 14.4304 10.9798 14.3711 11.0852 14.2656C11.1907 14.1601 11.25 14.0171 11.25 13.8679V5.60925C11.25 5.46007 11.1907 5.31699 11.0852 5.21151C10.9798 5.10602 10.8367 5.04675 10.6875 5.04675C10.5383 5.04675 10.3952 5.10602 10.2898 5.21151C10.1843 5.31699 10.125 5.46007 10.125 5.60925V13.8679C10.125 14.0171 10.1843 14.1601 10.2898 14.2656C10.3952 14.3711 10.5383 14.4304 10.6875 14.4304ZM7.59375 14.4304C7.74293 14.4304 7.88601 14.3711 7.9915 14.2656C8.09699 14.1601 8.15625 14.0171 8.15625 13.8679V5.60925C8.15625 5.46007 8.09699 5.31699 7.9915 5.21151C7.88601 5.10602 7.74293 5.04675 7.59375 5.04675C7.44457 5.04675 7.30149 5.10602 7.196 5.21151C7.09051 5.31699 7.03125 5.46007 7.03125 5.60925V13.8679C7.03125 14.0171 7.09051 14.1601 7.196 14.2656C7.30149 14.3711 7.44457 14.4304 7.59375 14.4304Z",
    fill: "black"
  })
], -1))
const _hoisted_3 = { class: "head flex-ter" }
const _hoisted_4 = { style: {"color":"#fff"} }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  style: {"height":"60px","padding":"0 20px","justify-content":"space-between","color":"#CA9C00","font-weight":"500"},
  class: "flex-ter cart-bar"
}
const _hoisted_8 = { style: {"line-height":"20px"} }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "body" }

import { t } from '@/plugins/i18n'
import { ref, computed, reactive, watch } from 'vue'
import CheckBox from './CheckBox.vue'
import ShopItem from './ShopItem.vue'
import additional from './additional.vue'
import { deleteSku } from '@/apis/shopcart'
import { confirmClearCart } from '@/util/useConfirm'
import { isD2C, useRtfix, isJA } from '@/store'
import QuestionMark from '@/components/IconPark/QuestionMark.vue'

export default /*#__PURE__*/_defineComponent({
  props: [
  'list',
  'listCheckMap',
  'layout',
  'cartIdList',
  'mode'
],
  emits: ['update', 'calc'],
  setup(__props, { emit }) {

const props = __props
const shopTableDeliverHasTip = ref(localStorage.shopTableDeliverHasTip)
watch(shopTableDeliverHasTip, () => {
  localStorage.shopTableDeliverHasTip = 'has'
})




// const listCheckMap = ref(props.listCheckMap)
const listCheckMap: any = ref([])
watch(() => props.listCheckMap, (newValue) => {
  listCheckMap.value = newValue
}, {
  deep: true,
  immediate: true
})
// 全选按钮点击固定取反，不判断当前状态
let checkAllValue = true
const checkAll = computed({
  get: () => {
    const arr = Object.values(listCheckMap.value)
    return arr.length && arr.every((v) => v)
  },
  set: (val) => {
    checkAllValue = !checkAllValue
    Object.keys(listCheckMap.value).forEach((k) => (listCheckMap.value[k] = checkAllValue))
  }
})

const isIndeterminate = computed(
  () => !checkAll.value && Object.values(listCheckMap.value).some((v) => v)
)

const updateList = ({ type, val }: any) => {
  if (type === 'delete') {
    delete listCheckMap.value[val.cartId]
    emit('update')
  } else if (type === 'check') {
    val[0].forEach((id: number) => {
      listCheckMap.value[id] = val[1]
    })
  } else if (!type) {
    emit('update')
  }
}

const handleClear = () => {
  const cartIdList = props.cartIdList
  if (!cartIdList.length) return
  confirmClearCart(
    () => {
      deleteSku({ cartIdList }).then(() => {
        emit('update')
        cartIdList.forEach((k: number) => {
          delete listCheckMap.value[k]
        })
      })
    },
    () => { }
  )
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: "abs trash",
      onClick: handleClear,
      style: _normalizeStyle({ top: !_unref(isD2C)() ? '-51px' : '-30px' })
    }, [
      _createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "light",
        content: _unref(t)('一键删除'),
        placement: "top"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["content"])
    ], 4), [
      [_vShow, __props.cartIdList.length]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CheckBox, {
        class: "select-all-class",
        modelValue: _unref(checkAll),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checkAll) ? (checkAll).value = $event : null)),
        indeterminate: _unref(isIndeterminate)
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('全选')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "indeterminate"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.layout, (v) => {
        return (_openBlock(), _createElementBlock("div", {
          key: v.label,
          class: _normalizeClass({ 'fx-1': v.width === 'auto' }),
          style: _normalizeStyle({ width: (v.headerWidth || v.width) + 'px' })
        }, [
          _createTextVNode(_toDisplayString(typeof v?.fix === 'function' ? v?.fix(v.label) : v.label) + " ", 1),
          (v.name === 'customSku')
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                effect: "light",
                placement: "top",
                "popper-class": "tool-tip-no-border"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", {
                    style: _normalizeStyle({ maxWidth: _unref(isJA)() ? '520px' : '300px' })
                  }, [
                    _createElementVNode("div", {
                      innerHTML: _unref(t)('商品SKU作用旨在区分相同商品的不同规格、尺寸、颜色等。')
                    }, null, 8, _hoisted_5),
                    _createElementVNode("div", {
                      innerHTML: _unref(t)('您可以直接填写自家店铺现有的的商品SKU，也可以额外设置新的SKU。')
                    }, null, 8, _hoisted_6)
                  ], 4)
                ]),
                default: _withCtx(() => [
                  _createVNode(QuestionMark, {
                    size: 14,
                    color: "#fff"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 6))
      }), 128))
    ]),
    (__props.mode && !shopTableDeliverHasTip.value && _unref(isD2C)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(t)('当前订单包含需采购的商品，如遇到商品无法采购等情况导致取消时，将通过异常联络通知您，您可在中更改默认项').split('\n'), (v) => {
              return (_openBlock(), _createElementBlock("span", { key: v }, _toDisplayString(v), 1))
            }), 128)),
            _createVNode(_component_router_link, {
              to: _unref(useRtfix)('setupShop', { query: { type: 'ShopGroup' } }),
              style: {"color":"var(--blcolor)","margin-left":"10px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  innerHTML: _unref(t)('店铺配置->发货设置')
                }, null, 8, _hoisted_9)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("img", {
            style: {"height":"20px","cursor":"pointer"},
            src: _imports_0,
            alt: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (shopTableDeliverHasTip.value = true))
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(additional),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (v) => {
        return (_openBlock(), _createBlock(ShopItem, {
          key: v.cartGroupNo,
          layout: __props.layout,
          data: v,
          mode: __props.mode,
          checkMap: listCheckMap.value,
          onUpdate: updateList,
          onCalc: _cache[2] || (_cache[2] = (e) => emit('calc', e))
        }, null, 8, ["layout", "data", "mode", "checkMap"]))
      }), 128))
    ])
  ]))
}
}

})